module.exports = __webpack_public_path__ + "static/media/users.1f316a07.svg";